
<div>
    <v-card
        flat
        :ripple      = "false"
        @contextmenu = "showContext"
        class        = "pa-0 ma-0 h-100"
    >
        <drag
            @cut      = "onRemove(document)"
            :type     = "docData(document)"
            :data     = "docData(document)"
            :disabled = "!enableDrag"
            class     = "v-flex h-100"
        >
            <a @click="onDocument" class="w-100" >
                <p-dms-detail-menu-entry-label :document = document />
            </a>
        </drag>
    </v-card>
    <v-menu
        v-if          = "enableMenu"
        v-model       = "showContectMenu"
        content-class = "menu-class"
        :position-x   = "x"
        :position-y   = "y"
        offset-y
    >
        <v-list style="cursor: pointer; border: none; box-shadow: none">
            <v-list-item @click="onShowDocument">
                <div>
                    <i class="fas fa-eye"></i>
                    <span class="ml-3">anzeigen</span>
                </div>
            </v-list-item>
            <v-list-item @click="onFadeInDocument">
                <div class="v-flex">
                    <v-icon class="ml-n1" size="22" color="black">mdi-open-in-new</v-icon>
                    <div class="ml-3">einblenden</div>
                </div>
            </v-list-item>
            <v-list-item
                @click="onConfirmDetach"
                v-if="(!document.stamped && document.messageId) && document.typename !== 'Mail - gesendet' && !document.referenced">
                <div>
                    <i class="fas fa-unlink"></i>
                    <span class="ml-3">vom Ereignis lösen</span>
                </div>
            </v-list-item>
            <v-list-item @click="onConfirmDelete" v-if="(!document.messageId || document.stamped) && !document.referenced">
                <div>
                    <i class="fas fa-trash-alt"></i>
                    <span class="ml-3">löschen</span>
                </div>
            </v-list-item>
            <v-list-item @click="onDownload">
                <div>
                    <i class="fas fa-download"></i>
                    <span class="ml-3">Download</span>
                </div>
            </v-list-item>
        </v-list>
    </v-menu>
</div>
